<template>
  <v-switch
    class="ml-2 mt-0"
    inset
    dense
    hide-details="auto"
    v-model="item.value"
    :label="item.label"
    :disabled="disabled || item.readonly"
    @change="onChange"
  >
<!--     <template v-slot:label>
      {{item.label}}
      <br/><div class="text-caption" >{{item.hint}}</div>
    </template> -->
  </v-switch>
</template>

<script>
  export default {
    name: 'p-switch',
    props: {
      item: Object,
      disabled: { type: Boolean, default: false },
      index: Number
    },
    data: () => ({
    }),
    methods: {
      onChange(value) {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value, index: this.index })
      }
    }
  }
</script>